import { Component, Input, Output, EventEmitter, ViewChildren, QueryList, ElementRef, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { ProdutoComEmpresaView } from 'src/app/shared/models/produto.model';

@Component({
    selector: 'app-grid-produtos',
    templateUrl: './grid-produtos.component.html',
    styleUrls: ['./grid-produtos.component.scss'],
})
export class GridProdutosComponent {
    @ViewChildren('acrescimoPorcentoInput') acrescimoPorcentoInputs!: QueryList<ElementRef>;
    @ViewChildren('acrescimoReaisInput') acrescimoReaisInputs!: QueryList<ElementRef>;
    @ViewChildren('precoFinalInput') precoFinalInputs!: QueryList<ElementRef>;

    @Input() plataformaSelecionada: number = 0;
    @Input() produtos: ProdutoComEmpresaView[] = [];
    @Input() indexItemSelecionado: number = -1;
    // @Input() inputFocado: boolean = false;
    @Output() alterarProduto = new EventEmitter<ProdutoComEmpresaView>();
    @Output() alterarIndexItemSelecionado = new EventEmitter<number>();
    @Output() statusProduto = new EventEmitter<ProdutoComEmpresaView>();

    produtos_Copia: ProdutoComEmpresaView[] = [];

    // @HostListener('document:keyup', ['$event'])
    // keyup(event: KeyboardEvent) {
    //   if (event.key === 'Enter' && !this.inputFocado) {
    //     this.ativarDesativarProduto();
    //   }
    // }

    ngOnChanges(changes: SimpleChanges): void {
        const produtosChange = changes['produtos'];        

        if (produtosChange && produtosChange.currentValue) {
            if (produtosChange.currentValue.length > 0) {
                this.produtos_Copia = [...produtosChange.currentValue];                
            }
        }
    }

    public getCor(nomePessoaIntegracao: string): string {
        switch (nomePessoaIntegracao.toUpperCase()) {
            case 'IFOOD':
                return '#FF3C3C';
            case 'QUERO DELIVERY':
                return '#6C3995';
            case 'CARDAPIO ONLINE':
                return '#2FAC58';
            default:
                return '#000000';
        }
    }

    public focoInputAcrescimo(produtoParam: ProdutoComEmpresaView, event: Event, campo: 'acrescimoPorcento' | 'acrescimoReais' | 'precoFinal', index: number) {
        event.preventDefault();
        produtoParam.calcularPrecoFinal();

        switch (campo) {
            case 'acrescimoPorcento':
                setTimeout(() => this.acrescimoReaisInputs.toArray()[index].nativeElement.focus());
                break;
            case 'acrescimoReais':
                setTimeout(() => this.precoFinalInputs.toArray()[index].nativeElement.focus());
                break;
            case 'precoFinal':                
                const proximoInp = this.acrescimoPorcentoInputs.toArray()[index + 1];
                
                if (index < this.produtos_Copia.length - 1 && proximoInp !== undefined) {
                    setTimeout(() => proximoInp.nativeElement.focus());
                } else {
                    const primeiroInp = this.acrescimoPorcentoInputs.toArray()[0].nativeElement;
                    setTimeout(() => primeiroInp.focus());
                }

                this.alterarItemSelecionado(index + 1);
        }
    }

    public alterarItemSelecionado(index: number) {
        this.alterarIndexItemSelecionado.emit(index);
    }

    // public ativarDesativarProduto() {
    //   this.produtos[this.indexItemSelecionado].checked = !this.produtos[this.indexItemSelecionado].checked;
    //   this.alterarStatusProduto(this.produtos[this.indexItemSelecionado]);
    // }

    public alterarStatusProduto(produto: ProdutoComEmpresaView) {
        this.statusProduto.emit(produto);
    }

    public alterarValorProduto(produto: ProdutoComEmpresaView) {        
        produto.calcularPrecoFinal();
        this.alterarProduto.emit(produto);  
    }
}
